import auth from "./js/auth";
import Vue from "vue";
import VueRouter from "vue-router";

//Apps
import App from "./views/App.vue"
import StudentApp from "./views/Student/Home/App.vue"
import AdminApp from "./views/Admin/Home/App.vue"

//Navigations-Student
import StudentHome from "./views/Student/Home/Home.vue"
import FeeStatement from "./views/Student/Documents/FeeStatement.vue"
import NetBill from "./views/Student/Documents/NetBill.vue"
import T4A from "./views/Student/Documents/T4A.vue"
import T2202A from "./views/Student/Documents/T2202A.vue"

//Navigations-Admin
import AdminHome from "./views/Admin/Home/Home.vue"
import Config from "./views/Admin/Functions/Config.vue"
import Announcements from "./views/Admin/Functions/Announcements.vue"
import NetBillingAdmin from "./views/Admin/Functions/NetBillingAdmin.vue"
import T2202AAdmin from "./views/Admin/Functions/T2202AAdmin.vue"
import StudentData from "./views/Admin/Functions/StudentData.vue"
import ITSOnly from "./views/Admin/ITSFunction/ITS.vue"


//Access Controls
import Unauthenticated from "./views/AccessControl/Unauthenticated.vue"
import Unauthorized from "./views/AccessControl/Unauthorized.vue"
import LoginDisabled from "./views/AccessControl/LogInDisabled.vue"

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "hash",
    routes: [
        {
            path: "*",
            beforeEnter: redirect
        },
        {
            path: "/",
            name: "",
            alias: '/',
            component: App,
            children: [
                {
                    path: '/',
                    name: "StudentApp",
                    alias: '/',
                    component: StudentApp,
                    children: [
                        {
                            path: '',
                            alias: '',
                            component: StudentHome,
                            beforeEnter: checkStudent
                        },
                        {
                            path: '/home',
                            alias: '',
                            component: StudentHome,
                            beforeEnter: checkStudent
                        },
                        {
                            path: '/feestatement',
                            alias: '/feestatement',
                            component: FeeStatement,
                            beforeEnter: feestatementAccess
                        },
                        {
                            path: '/netbill',
                            alias: '/netbill',
                            component: NetBill,
                            beforeEnter: netbillAccess
                        },
                        {
                            path: '/t4a',
                            alias: '/t4a',
                            component: T4A,
                            beforeEnter: t4aAccess
                        },
                        {
                            path: '/t2202a',
                            alias: '/t2202a',
                            component: T2202A,
                            beforeEnter: t2202aAccess
                        }
                    ],
                    beforeEnter: checkStudent
                },
                {
                    path: '/admin',
                    name: "AdminApp",
                    alias: '/admin',
                    component: AdminApp,
                    children: [
                        {
                            path: '',
                            alias: '',
                            component: AdminHome,
                            beforeEnter: checkAdmin
                        },
                        {
                            path: '/home',
                            alias: '',
                            component: AdminHome,
                            beforeEnter: checkAdmin
                        },
                        {
                            path: '/config',
                            alias: '/config',
                            component: Config,
                            beforeEnter: checkAdmin
                        },
                        {
                            path: '/announcements',
                            alias: '/announcements',
                            component: Announcements,
                            beforeEnter: checkAdmin
                        },
                        {
                            path: '/netbilladmin',
                            alias: '/netbilladmin',
                            component: NetBillingAdmin,
                            beforeEnter: checkAdmin
                        },
                        {
                            path: '/t2202aadmin',
                            alias: '/t2202aadmin',
                            component: T2202AAdmin,
                            beforeEnter: checkAdmin
                        },
                        {
                            path: '/studentdata',
                            alias: '/studentdata',
                            component: StudentData,
                            beforeEnter: checkAdmin
                        },
                        {
                            path: '/itsonly',
                            alias: '/itsonly',
                            component: ITSOnly,
                            beforeEnter: checkITS
                        }
                    ],
                    beforeEnter: checkAdmin
                }
            ],
            beforeEnter: requireAuth  
        },
        {
            path: "/unauthenticated",
            name: "unauthenticated",
            alias: "/unauthenticated",
            component: Unauthenticated,
            beforeEnter: checkAuthentication
        },
        {
            path: "/unauthorized",
            name: "unauthorized",
            alias: "/unauthorized",
            component: Unauthorized,
            beforeEnter: checkAuthorization
        },
        {
            path: "/undermaintenance",
            name: "undermaintenance",
            alias: "/undermaintenance",
            component: LoginDisabled,
        }
    ]
});

function checkAdmin(to, from, next) {
    // Check if the user is an admin
    if (auth.is_AdminMember()) {
        // Redirect to admin dashboard
        next();
    } else {
        // Otherwise redirect to unauthorized view
        next({
            path: '/unauthorized'
        })
    }
}

function checkITS(to, from, next){
    // Check if the user is an admin & ITS
    if (auth.is_ITS()) {
        // Redirect to its only page
        next();
    } else {
        // Otherwise redirect to admin home
        next({
            path: '/'
        })
    }
}

function checkStudent(to, from, next) {
    // Check if the user is not an admin
    if (auth.is_Student()) {
        // Redirect to student dashboard if login is enabled
        //Otherwise to Maintenance page
        if(auth.login_enabled() == false){
            next({
                path: "/undermaintenance"
            })
        }else {
            next();
        }
    } else {
        next({
            path: '/unauthorized'
        })
    }
}

function checkAuthentication(to, from, next) {
    // Check user authentication
    auth.authenticate().then(function (response) {
            if (response) {
                // Redirect to proper route
                redirectTo(next);
            } else {
                // Redirect to unauthenticated view
                next();
            }
        })
        .catch(function () {
            // Redirect to unauthenticated view
            next();
        })
}

function checkAuthorization(to, from, next) {
    // Check user authentication
    if(!auth.is_AdminMember() && !auth.is_Student()){
        next();
    }else {
        if(auth.is_AdminMember()){
            next({
                path: '/admin'
            });
        }else if(auth.is_Student()){
            next({
                path: '/'
            });
        }else {
            next();
        }
    }
}

function redirect(to, from, next) {
    // Redirect all paths to unauthenticated check
    next({
        path: '/unauthenticated'
    });
}

function redirectTo(next) {
    // Redirect based on session type
    if (auth.is_Student()) {
        next({
            path: '/'
        });
    }else if(auth.is_AdminMember()){
        next({
            path: "/admin"
        });
    }else{
        next({
            path: '/unauthorized'
        });
    }
}

function requireAuth(to, from, next) {
    // Check if user is authenticated
    auth.authenticate().then(function (response) {
        if (response) {
            // Navigate to specified view if authenticated
            next();
        } else {
            // Redirect to unauthenticated view
            next({
                path: '/unauthenticated'
            })
        }
    }).catch(function () {
        // Redirect to unauthenticated view
        next({
            path: '/unauthenticated'
        })
    })
}

//Below starts routing options for document access

function feestatementAccess(to, from, next){
    var config = auth.get_user().config;
    if(config.statement.match(/^Yes/i)){
        checkStudent(to, from, next);
    }else {
        next({
            path: "/"
        });
    }
}

function netbillAccess(to, from, next){
    var config = auth.get_user().config;
    if(config.netbill.match(/^Yes/i)){
        checkStudent(to, from, next);
    }else {
        next({
            path: "/"
        });
    }
}

function t4aAccess(to, from, next){
    var config = auth.get_user().config;
    if(config.t4a.match(/^Yes/i)){
        checkStudent(to, from, next);
    }else {
        next({
            path: "/"
        });
    }
}

function t2202aAccess(to, from, next){
    var config = auth.get_user().config;
    if(config.t2202a.match(/^Yes/i)){
        checkStudent(to, from, next);
    }else {
        next({
            path: "/"
        });
    }
}
export default router;